import {
  BULK_DELETE_WARNING,
  BULK_LOCK_WARNING,
  BULK_UNLOCK_WARNING,
  ListMenuItem,
  Typography,
  newToast,
} from "@compass/core";
import { Permission, PermissionAction } from "generated/openApi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import { isAuthorized } from "services";
import ApiService from "services/apiService";
import {
  staffServiceBulkUpdatePageRoute,
  StaffServiceBulkUpdatePageState,
} from "../StaffServiceBulkUpdatePage/StaffServiceBulkUpdatePage";

export const useStaffServiceListMenuItems = (props: {
  permission: Permission;
  loadList: () => void;
  setSelectedIds: (value: number[]) => void;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const menuItems: ListMenuItem[] = [];

  if (isAuthorized(props.permission, PermissionAction.Update))
    menuItems.push({
      label: "Update",
      action: (selectedIds: number[]) =>
        navigate(staffServiceBulkUpdatePageRoute.getPath(), {
          state: { selectedIds: selectedIds } as StaffServiceBulkUpdatePageState,
        }),
    });

  // if (isAuthorized(props.permission, PermissionAction.BulkDelete))
  //   menuItems.push({
  //     label: <Typography color="error">Delete</Typography>,
  //     action: (selectedIds: number[]) => {
  //       if (window.confirm(BULK_DELETE_WARNING))
  //         ApiService.staffServices.postBulkDelete(selectedIds).then(() => {
  //           props.setSelectedIds([]);
  //           dispatch(setAppToast(newToast("success")));
  //           props.loadList();
  //         });
  //     },
  //   });

  return menuItems;
};
